// Toggles the visitor's light/dark preference on <html data-scheme> and remembers it.
// The layout head applies the saved value before first paint to avoid a flash.
const STORAGE_KEY = 'elev8-scheme';

class SchemeToggle extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('command', this.#onCommand, { signal: this.#abort.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #onCommand = (event) => {
    if (event.command !== '--toggle') return;
    const root = document.documentElement;
    const next = root.dataset.scheme === 'light' ? 'dark' : 'light';
    root.dataset.scheme = next;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      // Storage can be unavailable (private mode); the toggle still works for this page view.
    }
    this.#sync();
  };

  #sync() {
    const isLight = document.documentElement.dataset.scheme === 'light';
    this.querySelectorAll('button[command="--toggle"]').forEach((button) => {
      button.setAttribute('aria-pressed', String(isLight));
    });
  }
}

if (!customElements.get('s-scheme-toggle')) {
  customElements.define('s-scheme-toggle', SchemeToggle);
}
